import { requestApi } from '@app/api';
import { withDocument } from '@app/api/paths';

interface ResourceRole {
  id: string;
  workspaceId: string;
  editingDocumentId: string;
  subjectType: 'MEMBER' | 'GROUP';
  name: 'EDITOR' | 'VIEWER';
  createdAt: string;
  updatedAt: string;
}

interface GetEditingDocumentRolesParams {
  limit?: number;
  offset?: number;
  subjects?: (`MEMBER/${string}` | `GROUP/${string}`)[];
}
interface GetEditingDocumentRolesResponse {
  count: number;
  editingDocumentRoles: {
    id: string;
    workspaceId: string;
    editingDocumentId: string;
    subjectType: 'MEMBER' | 'GROUP';
    member?: {
      id: string;
      name: string;
      description: string;
      userId: string;
      userName: string;
      userEmail: string;
    };
    group?: { id: string; name: string; type: 'ALL_MEMBERS' | 'CUSTOM'; description: string };
    name: 'VIEWER' | 'EDITOR';
    createdAt: string;
    updatedAt: string;
  }[];
}

/**
 * GET 편집 문서 공유 조회
 */
export function getEditingDocumentRoles(
  workspaceId: string,
  editingDocumentId: string,
  { limit = 10, ...params }: GetEditingDocumentRolesParams
): Promise<GetEditingDocumentRolesResponse> {
  return requestApi<GetEditingDocumentRolesResponse>({
    url: withDocument(`/workspaces/${workspaceId}/editing-documents/${editingDocumentId}/roles`),
    method: 'GET',
    credentials: true,
    params: { ...params, limit },
  }).then((response) => response.data);
}

interface PatchEditingDocumentsRolesData {
  editingDocumentRoles: Pick<ResourceRole, 'editingDocumentId' | 'subjectType' | 'name'> &
    { subjectId: string }[];
}
interface PatchEditingDocumentsRolesResponse {
  errors: number;
  results: Pick<ResourceRole, 'id'>[];
}

/**
 * PATCH 편집 문서 공유 수정
 */
export function patchEditingDocumentsRoles(
  workspaceId: string,
  data: PatchEditingDocumentsRolesData
): Promise<PatchEditingDocumentsRolesResponse> {
  return requestApi<PatchEditingDocumentsRolesResponse>({
    url: withDocument(`/workspaces/${workspaceId}/editing-documents/roles`),
    method: 'PATCH',
    credentials: true,
    data,
  }).then((response) => response.data);
}
